import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";

const PromoBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("promo_banner_dismissed");
    if (!dismissed) setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem("promo_banner_dismissed", "1");
    setVisible(false);
  };

  const scrollToPricing = () => {
    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative z-50 gradient-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm font-semibold text-center">
        <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
        <span className="truncate">
          🎉 Launch offer: <span className="underline">+10 bonus credits</span> on your first purchase — limited time
        </span>
        <button
          onClick={scrollToPricing}
          className="hidden sm:inline-block px-3 py-1 rounded-full bg-white/20 hover:bg-white/30 transition text-xs font-bold whitespace-nowrap"
        >
          Claim now
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss promotional banner"
          className="ml-1 sm:ml-2 p-1 rounded-full hover:bg-white/20 transition"
        >
          <X className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;